import posthog from "posthog-js";

const posthogToken = process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN;

function syncPosthogConsent(): void {
  const cookiebot = (
    window as Window & { Cookiebot?: { consent?: { statistics?: boolean } } }
  ).Cookiebot;
  if (cookiebot?.consent?.statistics) {
    posthog.opt_in_capturing();
  } else {
    posthog.opt_out_capturing();
  }
}

if (posthogToken && process.env.NEXT_PUBLIC_VERCEL_ENV === "production") {
  posthog.init(posthogToken, {
    api_host: "/ingest",
    ui_host: "https://us.posthog.com",
    defaults: "2026-01-30",
    capture_exceptions: true,
    opt_out_capturing_by_default: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "[data-ph-mask]",
    },
    debug: process.env.NODE_ENV === "development",
  });

  syncPosthogConsent();
  for (const event of [
    "CookiebotOnConsentReady",
    "CookiebotOnAccept",
    "CookiebotOnDecline",
  ]) {
    window.addEventListener(event, syncPosthogConsent);
  }
}
